// exports.newUrl = "http://localhost:5000"

exports.rootUrl = "https://2not7rklia.execute-api.ap-south-1.amazonaws.com/dev";

exports.newUrl = "https://dev.locad.net/plano";
// exports.newUrl = "http://13.233.167.6/plano/";

exports.fetchSiteCount = 1000;

exports.mapCampaignUrl = "http://locauditapidev.locad.net";


// WEBPACK FOOTER //
// ./src/utility.js